// src/sidebar/SidebarLink.js
import React from 'react';
import { NavLink } from 'react-router-dom';

const SidebarLink = ({ to, icon, children, isActive }) => {
  return (
    <NavLink 
      to={to} 
      className={({ isActive: routeIsActive }) => 
        `flex items-center gap-3 p-2 rounded-lg transition-colors ${
          isActive || routeIsActive 
            ? 'bg-white/20 text-white' 
            : 'text-white/80 hover:bg-white/10 hover:text-white'
        }`
      }
    >
      {icon}
      <span className="text-lg">{children}</span>
    </NavLink>
  );
};

export default SidebarLink;